// @flow

import { Col, COLORS, BORDER_WIDTH, SPACING, TYPE_SCALE } from 'clark-styles';
import styled from 'styled-components';

const { CLARK_PRIMARY, GREY_100, GREY_3, GREY_50 } = COLORS;

export const TabContainer = styled.div`
  background: ${GREY_3};
  width: 100%;
`;

export const StyledCol = styled<any>(Col)`
  display: flex;
  justify-content: flex-start;
`;

export const Tab = styled.div`
  text-transform: uppercase;
  display: inline-block;
  ${TYPE_SCALE.TS_6};
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? `${GREY_100}` : `${GREY_50}`)};
  margin-right: ${SPACING.S_4};
  padding-bottom: ${SPACING.S_1};
  border-bottom: ${({ isActive }) =>
    isActive ? `${BORDER_WIDTH.BW_3} solid ${CLARK_PRIMARY}` : 0};
`;



// WEBPACK FOOTER //
// ./src/components/tabs/styles.js